export const PACKAGE_VERSION = '1.6.8';
//# sourceMappingURL=constants.js.map